import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/images/search_token.png'


const _hoisted_1 = {
  key: 0,
  class: "mb:px-6 px-4 mt-6"
}
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "flex items-center justify-between px-6 mt-5" }
const _hoisted_4 = { class: "flex items-end flex-wrap" }
const _hoisted_5 = { class: "mb:text-base text-14px mb:mr-2 mr-0.5" }
const _hoisted_6 = { class: "flex items-center whitespace-nowrap text-12px text-permaWhite2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick", "onMouseover"]
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = { class: "w-8 h-8 relative" }
const _hoisted_11 = { class: "w-full rounded-full overflow-hidden" }
const _hoisted_12 = { class: "flex flex-col justify-between ml-3 text-14px" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "text-12px text-permaWhite2" }
const _hoisted_15 = {
  key: 0,
  class: "w-full flex items-center justify-end"
}
const _hoisted_16 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_17 = {
  key: 0,
  href: "https://a-bank.asiadb.com/#download_app",
  target: "_blank",
  class: "text-permaGreen4 cursor-pointer hover:text-permaGreen11 active:text-permaGreen9"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 2,
  class: "h-3 border border-opacity-20 border-white mx-3"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "w-9/12"
}
const _hoisted_22 = { class: "text-right text-14px font-space-gtotesk-medium transition-all truncate" }
const _hoisted_23 = { class: "text-12px text-right text-permaWhite2" }
const _hoisted_24 = { key: 1 }

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoreInfo from './common/MoreInfo.vue'
import { useStore } from '@/store'
import { formatMoney, formatChainTypeDisplay } from '@/libs/util'
import TokenLogo from './TokenLogo.vue'
import ChainTypeLogo from './ChainTypeLogo.vue'
import { Token } from '@/libs/everpay-js'
import { isProd } from '@/constants'
import { toBN } from '@/libs/everpay-js/utils/util'
interface Props {
  tokens: Token[]
  selectedToken: Token | null
  isModal: boolean
  selectTitle:string
  displayAssetsBalance: boolean
}
interface Emits {
  (e: 'select', token:Token):void
  (e: 'toSwap', symbol: string):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    tokens: null,
    selectedToken: null,
    isModal: null,
    selectTitle: null,
    displayAssetsBalance: null
  },
  emits: ["select", "toSwap"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'select', token:Token):void
  (e: 'toSwap', symbol: string):void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tokens: Token[]
  selectedToken: Token | null
  isModal: boolean
  selectTitle:string
  displayAssetsBalance: boolean
}



const { t } = useI18n()
const store = useStore()
const searchSymbol = ref('')
const isHover = ref(false)
const isFocus = ref(false)
const account = computed(() => store.state.account)
const hoverd = ref(-1)
const currencyPricesStack = computed(():any => {
  const result = {}
  store.state.currencyPrices.forEach(currencyPriceItem => {
    (result as any)[currencyPriceItem.symbol] = currencyPriceItem.price
  })
  return result
})
const isSelectTeam = computed(() => {
  return ['隊伍', 'Team'].includes(props.selectTitle)
})
const swapTokenList = computed(() => store.state.swapInfo.tokenList)
const balances = computed(() => {
  return props.tokens.map((t) => {
    const balanceItem = store.state.everpayBalances.find((item) => item.tag?.toUpperCase() === t.tag.toUpperCase())
    const balance = !account.value ? '-' : (balanceItem ? balanceItem.balance : '0')
    const currencyPrice = !account.value ? '0' : currencyPricesStack.value[t.symbol] * (balance as any)
    return {
      tag: t.tag,
      token: t,
      symbol: t.symbol,
      chainType: t.chainType,
      balance,
      currencyPrice
    }
  }).sort((blanaceItem1: any, blanaceItem2: any) => {
    return blanaceItem2.currencyPrice - blanaceItem1.currencyPrice
  }).map((item: any) => {
    const isSwapToken = swapTokenList.value.find((t) => t.toLocaleLowerCase() === item.tag.toLocaleLowerCase())
    return {
      tag: item.tag,
      token: item.token,
      symbol: item.symbol,
      chainType: formatChainTypeDisplay(item.chainType),
      balance: toBN(item.balance).toString(),
      currencyPrice: formatMoney(item.currencyPrice),
      isSwap: !!isSwapToken,
      isDeposit: true
    }
  }).filter((item: any) => {
    if (searchSymbol.value) {
      return item.symbol.toUpperCase().includes(searchSymbol.value.toUpperCase())
    }
    return true
  })
})
const select = (token:Token) => {
  if (token) {
    emits('select', token)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isSelectTeam))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["border border-solid bg-permaMain rounded-xl py-3 px-4 flex", isHover.value||isFocus.value ? 'border-permaGreen4' : 'border-permaGreen10 hover:border-permaGreen11']),
            onMousemove: _cache[3] || (_cache[3] = ($event: any) => (isHover.value = true)),
            onMouseout: _cache[4] || (_cache[4] = ($event: any) => (isHover.value = false))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchSymbol).value = $event)),
              placeholder: _unref(t)('search'),
              class: "text-base focus:outline-none bg-transparent w-full",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (isFocus.value = true)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (isFocus.value = false))
            }, null, 40, _hoisted_2), [
              [_vModelText, searchSymbol.value]
            ]),
            _createElementVNode("img", {
              src: _imports_0,
              class: _normalizeClass(["w-6 h-6 cursor-pointer", isHover.value || isFocus.value ? 'opacity-100' : 'opacity-65']),
              alt: "search"
            }, null, 2)
          ], 34)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.selectTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_unref(t)('everpay_balance')), 1),
        _createVNode(MoreInfo, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('balance_more_info')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(["px-4 overflow-y-scroll scroll-area mt-4", !_unref(balances).length ? 'flex flex-col justify-center items-center' : '']),
      style: _normalizeStyle(__props.isModal ? 'height:396px': _unref(account) ? 'height:100vh;padding-bottom:450px' : 'height:100vh;padding-bottom:370px')
    }, [
      (!_unref(balances).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('no_result')), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(balances), (balanceItem, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: balanceItem.tag,
          class: _normalizeClass([__props.selectedToken ? `${__props.selectedToken.symbol === balanceItem.symbol ? '' : '' }` : '', "flex flex-row items-center justify-between p-2 cursor-pointer rounded-xl mb-2 transition-colors hover:bg-permaGreen13"]),
          onClick: ($event: any) => (select(balanceItem.token)),
          onMouseover: ($event: any) => (hoverd.value = index),
          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (hoverd.value = -1))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(TokenLogo, {
                  class: "block w-8 h-8",
                  symbol: balanceItem.symbol
                }, null, 8, ["symbol"])
              ]),
              (balanceItem.symbol !== 'ACNH')
                ? (_openBlock(), _createBlock(ChainTypeLogo, {
                    key: 0,
                    class: "block w-4 h-4 absolute right-0 bottom-0 border border-permaGray4 rounded-full",
                    symbol: balanceItem.chainType
                  }, null, 8, ["symbol"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(balanceItem.symbol), 1),
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(isSelectTeam) ? '2022FIFA-Fianl' : balanceItem.chainType), 1)
            ])
          ]),
          (_unref(account))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (hoverd.value === index && !__props.isModal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (balanceItem.symbol === 'ACNH')
                        ? (_openBlock(), _createElementBlock("a", _hoisted_17, _toDisplayString(_unref(t)('deposit')), 1))
                        : (balanceItem.isDeposit)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "text-permaGreen4 cursor-pointer hover:text-permaGreen11 active:text-permaGreen9",
                              href: `https://app${_unref(isProd) ? '' : '-dev'}.everpay.io/deposit/${balanceItem.tag}`,
                              target: "_blank"
                            }, _toDisplayString(_unref(t)('deposit')), 9, _hoisted_18))
                          : _createCommentVNode("", true),
                      (balanceItem.isDeposit && balanceItem.isSwap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                        : _createCommentVNode("", true),
                      (balanceItem.isSwap)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: "text-permaGreen4 cursor-pointer hover:text-permaGreen11 active:text-permaGreen9",
                            onClick: ($event: any) => (emits('toSwap', balanceItem.symbol))
                          }, _toDisplayString(_unref(t)('swap')), 9, _hoisted_20))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(__props.displayAssetsBalance ? '****' : balanceItem.balance), 1),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(__props.displayAssetsBalance ? '****' : _unref(currencyPricesStack)[balanceItem.symbol] === '0' ? '-.-' : `$${balanceItem.currencyPrice}`), 1)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(__props.isModal ? '0' : '-'), 1))
        ], 42, _hoisted_8))
      }), 128))
    ], 6)
  ], 64))
}
}

})